import React, { useState } from 'react';
import { IAdBannerData } from 'types/IAdBannerData';
import { tagEvent } from 'utils/ga';
import './SmallAdBanner.less';
import clsx from 'clsx';
import { Skeleton } from '@progress/kendo-react-indicators';

interface Props {
  banner?: IAdBannerData;
  className?: string;
}

export default function SmallAdBanner({ banner, className }: Props) {
  const [isLoaded, setIsLoaded] = useState(false);
  // const [isError, setIsError] = useState(false);

  function handleLoad() {
    setIsLoaded(true);
  }

  function handleError() {
    // setIsError(true);
    // handleLoad();
  }

  if (!banner) return null;

  function handleClick() {
    tagEvent('small_ad_click', { clicked: banner });
  }

  return (
    <div className={clsx('small-ad-banner', className)}>
      {!isLoaded && <Skeleton shape="rectangle" style={{ height: 128 }} />}

      <img
        src={banner.imageUrl}
        className={clsx('small-ad-banner__image', {
          'small-ad-banner__image_hidden': !isLoaded,
        })}
        onLoad={handleLoad}
        onError={handleError}
        fetchPriority="high"
        decoding="async"
        alt={banner.title}
      />

      <div className="small-ad-banner__content">
        <div className="small-ad-banner__title">{banner.title}</div>
        <div className="small-ad-banner__description">{banner.description}</div>

        <a
          className="small-ad-banner__button k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
          href="/target"
          target="_blank"
          rel="noreferrer"
          onClick={handleClick}
        >
          {banner.buttonLabel}
        </a>
      </div>
    </div>
  );
}
